module.exports = __webpack_public_path__ + "static/media/science.e652a4da.svg";